import * as React from 'react';

import Mobile32 from './Mobile32';

export const mobile32 = () => <Mobile32 />;

export default {
    title: 'Icon/Logo/Mobile32',
    component: Mobile32,
    parameters: {
        notes: "`import Mobile32 from 'box-ui-elements/es/icon/logo/Mobile32';`",
    },
};
